import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RefundRevenueCalculateProperties, RevenueManagementBaseData, RevenueManagementProperties, RevenueReportPropertise, Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { ActiveSuppliers, Agency_Branches } from '../Models/ActiveClasses';
import { BookingInfoProperties } from '../Models/BookingPassengerTicketIssuanceProperties';

@Injectable({
  providedIn: 'root'
})
export class RevenueManagementService {
  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  GetRevenueBaseData(): Observable<RevenueManagementBaseData> {
    return this.http.get<RevenueManagementBaseData>(this.baseUrl + '/RevenueManagement/GetRevenueManagementBaseData/')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementList(param, agency): Observable<RevenueManagementProperties[]> {
    return this.http.get<RevenueManagementProperties[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementList/' + param + "/" + agency)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementAgencies_Branches(param): Observable<Agency_Branches[]> {
    return this.http.get<Agency_Branches[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementAgencies_Branches/' + param )
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementSupplierByParent(param): Observable<ActiveSuppliers[]> {
    return this.http.get<ActiveSuppliers[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementSupplierByParent/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementSupplierAll(): Observable<ActiveSuppliers[]> {
    return this.http.get<ActiveSuppliers[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementSupplierAll' )
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementOficeIds(param): Observable<Supplier_OficeID[]> {
    return this.http.get<Supplier_OficeID[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementOficeIds/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueManagementOfficeIdsForImportPnr(param): Observable<Supplier_OficeID[]> {
    return this.http.get<Supplier_OficeID[]>(this.baseUrl + '/RevenueManagement/GetRevenueManagementOfficeIdsForImportPnr/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateRevenueManagement(obj): Observable<number> {
    return this.http.post<number>(this.baseUrl + '/RevenueManagement/CreateRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  UpdateRevenueManagement(obj): Observable<boolean> {
    return this.http.post<number>(this.baseUrl + '/RevenueManagement/UpdateRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetRevenueById(revenueId): Observable<RevenueManagementProperties> {
    return this.http.get<RevenueManagementProperties>(this.baseUrl + '/RevenueManagement/GetRevenueById/' + revenueId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


  CheckRightsAgaintAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/RevenueManagement/CheckRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  canEditRevenue(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/RevenueManagement/canEditRevenue/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  deleteRevenue(revenueId: number): Observable<boolean> {
    return this.http.delete<boolean>(this.baseUrl + '/RevenueManagement/Delete/' + revenueId)
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => {
          return throwError(error);
        })
      );
  }
  CreateRevenueManagementVoid(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/RevenueManagement/CreateVoidRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateRevenueManagementVoid(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/RevenueManagement/UpdateVoidRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  CreateRevenueManagementRefund(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/RevenueManagement/CreateRefundRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateRevenueManagementRefund(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/RevenueManagement/UpdateRefundRevenueManagement', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetRevenuevoidrefundById(revenueId): Observable<RevenueManagementProperties> {
    return this.http.get<RevenueManagementProperties>(this.baseUrl + '/RevenueManagement/GetRevenueByIdForVoidOrRefund/' + revenueId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetRevenueByAgencyId(revenueId,requestType): Observable<RefundRevenueCalculateProperties[]> {
    return this.http.get<RefundRevenueCalculateProperties[]>(this.baseUrl + '/RevenueManagement/GetRevenueByagencyId/' + revenueId + '/' + requestType)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
 
  SaveStatusListRevenue(status,revenueid, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/RevenueManagement/SaveStatusListRevenue/' + status + "/" + revenueid + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }
  ApplyRefundRevenue(refundRequest): Observable<BookingInfoProperties> {
    return this.http.post<BookingInfoProperties>(this.baseUrl + '/RevenueManagement/GetRevenueBysupForRefund', refundRequest)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //console.log(error);
        return throwError(error);
      }))
  }




  SaveRevenueReportData(RevenueReportData): Observable<RevenueReportPropertise> {
    return this.http.post<RevenueReportPropertise>(this.baseUrl + '/RevenueManagement/SaveRevenueReport', RevenueReportData)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  ModifyRevenueGroup(RevenueReportData): Observable<RevenueReportPropertise> {
    return this.http.post<RevenueReportPropertise>(this.baseUrl + '/RevenueManagement/ModifyRevenueGroup', RevenueReportData)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetRevenueReport(obj): Observable<RevenueManagementProperties[]> {
    return this.http.post<RevenueManagementProperties[]>(this.baseUrl + '/RevenueManagement/GetRevenueReport', obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetGroupRevenueReport(): Observable<RevenueReportPropertise[]> {
    return this.http.get<RevenueReportPropertise[]>(this.baseUrl + '/RevenueManagement/GetGroupRevenues')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetGroupRevenue(a: number): Observable<RevenueReportPropertise> {
    return this.http.get<RevenueReportPropertise>(this.baseUrl + '/RevenueManagement/GetGroupRevenueData/' + a)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetGroupRevenueByGroupId(a: number): Observable<RevenueReportPropertise> {
    return this.http.get<RevenueReportPropertise>(this.baseUrl + '/RevenueManagement/GetGroupRevenueDataByGroupID/' + a)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  //Adeel
  DelGroupRevenue(a: number): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/RevenueManagement/DeleteRevenueGroup/' + a)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetSupplierAllOfficeIds(param): Observable<Supplier_OficeID[]> {
    return this.http.get<Supplier_OficeID[]>(this.baseUrl + '/RevenueManagement/GetSupplierAllOfficeIds/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetInsuranceRevenueManagementSupplierByParent(param): Observable<ActiveSuppliers[]> {
    return this.http.get<ActiveSuppliers[]>(this.baseUrl + '/RevenueManagement/GetInsuranceRevenueManagementSupplierByParent/' + param)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
